import React from 'react'
import { connect } from 'react-redux'
import {
    resetError,
    defineScopeLoading
} from 'actions/spendActions'
import SavingContainer from "./SavingContainer";

import {
    GetRiseSavingDetails
} from 'actions/kpiActions'

class Saving extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            errorMsg: '',
            data: ''
        }
        this.loadData = this.loadData.bind(this);

    }

    componentDidMount() {
        this.loadData()
    }



    loadData() {
        let dmcId = this.props.spendDetails.currentActiveRequest.DMC_ID;
        let vsId = this.props.spendDetails.currentActiveRequest.VS_ID;
        let user = this.props.user.user.Email;

        this.props.defineScopeLoading(true);
        this.props.GetRiseSavingDetails(dmcId, vsId, user)
            .then((response) => {
                if (response.data.Result.Table.length > 0) {
                    let spData = response.data.Result.Table.filter(x => x.SAVING_FIELD_NAME == this.props.param);
                    this.setState({ data: spData })
                    this.props.defineScopeLoading(false)
                } else {
                    this.props.defineScopeLoading(false)
                    this.setState({ errorMsg: 'No Records Found.', isError: 'Yes', isLoading: false })
                }

            }).catch((error) => {
                if (error.stack.includes('Network Error')) {
                    this.props.defineScopeLoading(false)
                    this.setState({ errorMsg: 'API service is down. Please contact administrator.', isError: 'Yes', isLoading: false })
                }
                else {
                    this.props.defineScopeLoading(false)
                    this.setState({ errorMsg: this.props.content.error, isError: 'Yes', isLoading: false })
                }
            })
    }



    render() {

        return (
            <div className="kpiDashTable grid-x">
                <div className="medium-12">
                    <div className="tab-title">{this.props.param}</div>
                    {/* <div className="tab-description">{this.props.ganntTexts.tabDesc}</div> */}
                </div>
                {this.state.data.length > 0 ?
                    <SavingContainer data={this.state.data} options={this.props.options}/>
                    : null}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        ui: state.content.ui,
        userData: state.valueStory,
        user: state.default,
        content: state.content.spendAnalysis.worldMap,
        focusLabel: state.content.spendAnalysis.enablement.focusLabel,
        spendDetails: state.spendDetails,
        currencySymbols: state.content.CurrencySymbols,
        kpiFilters: state.kpis.kpiBenchMarkFilters,
        kpiLables: state.content.kpiTab
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        resetError: error => dispatch(resetError(error)),
        defineScopeLoading: bool => dispatch(defineScopeLoading(bool)),
        GetRiseSavingDetails: (DMCId, VSId, userEmail) => dispatch(GetRiseSavingDetails(DMCId, VSId, userEmail)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Saving)